import { render, staticRenderFns } from "./myPointItem.vue?vue&type=template&id=347db7d6&scoped=true&"
import script from "./myPointItem.vue?vue&type=script&lang=js&"
export * from "./myPointItem.vue?vue&type=script&lang=js&"
import style0 from "./myPointItem.vue?vue&type=style&index=0&id=347db7d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347db7d6",
  null
  
)

export default component.exports